<template>
  <section class="content__result">
    <ul
      id="content__list"
      :class="['content__list', contentListShow ? 'show' : '']"
    >
      <content-list-item
        v-for="content in contents"
        :key="content.id"
        :content="content"
        :selected-contents="selectedContents"
        :item-type="itemType"
        :label-class="content.labelClass"
        :has-checkbox="canDeleteContent && content.isSelectable"
        @focus-content="$emit('focus-content', $event)"
        @archive="$emit('archive', $event)"
        @update-selected-contents="$emit('update-selected-contents', $event)"
        @restore="$emit('restore', $event)"
        @delete="$emit('delete', $event)"
        @update-content="$emit('update-content', $event)"
        @update-content-verification="
          $emit('update-content-verification', $event)
        "
        @update-content-settings="
          $emit(
            'update-content-settings',
            Object.assign({}, $event, { id: content.id }),
          )
        "
      >
        <template v-slot:label-tag="{ labelTag }">
          <slot name="label-tag" v-bind:label-tag="labelTag"></slot>
        </template>
      </content-list-item>
    </ul>
    <span
      v-if="!moreOptions && contents.length > 20"
      class="text-muted display-more"
      @click="displayMoreSolutions"
      >{{ $t('knowledge.product.display-more') }}</span
    >
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import ContentListItem from './ContentListItem.vue';

export default {
  name: 'content-list',
  props: {
    contents: Array,
    selectedContents: Array,
    contentListShow: Boolean,
    moreOptions: Boolean,
    itemType: {
      type: String,
      default: 'content',
    },
    hasCustomLabel: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ContentListItem,
  },
  methods: {
    displayMoreSolutions() {
      this.$emit('display-more-solutions');
    },
  },
  computed: {
    canDeleteContent() {
      return (
        !!this.focusKnowledge.userPermissions &&
        Boolean(this.focusKnowledge.userPermissions.canDeleteContent)
      );
    },
    ...mapGetters('knowledgeModule', ['focusKnowledge']),
  },
};
</script>

<style lang="scss" scoped>
.content__list {
  padding-inline-start: 0px;
}

.display-more {
  cursor: pointer;
  &:hover {
    color: $blue-mayday !important;
  }
}

.label-tag_warning {
  color: $red-mayday;
}
</style>
